const routes = [
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/modules/onboarding/pages/Entry.vue'),
    meta: {
      requiresAuth: true,
      title: 'eRank — Onboarding',
      metaTags: [
        {
          name: 'description',
          content: 'Onboarding to help us understand your business and goals better.',
        },
        {
          page_slug: 'onboarding',
        },
      ],
    },
    children: [
      {
        path: 'newsletter',
        name: 'onboarding.newsletter',
        component: () => import('@/modules/onboarding/pages/Newsletter.vue'),
      },
    ],
  },
];
    
export default routes;
    